import * as React from "react";
import "./add-item-modal.less";
import { ModalComponent } from "shared/components/modal/modal";
import {
  formatMoney,
  redirectFileLocalUrl,
} from "shared/plugins/string-helper";
import {
  IProductItemSelectedModel,
  ShoppingCartItem,
} from "states/shopping-cart/shopping-cart.models";
import { IProductModel, IVariationAttributeModel, SelectGroupTypeEnum } from "states/menu/menu.models";
import { IconMinus, IconPlus, IconShoppingBag } from "themes";
import { calculateTotal } from "states/shopping-cart/shopping-cart.slice";
import { IVariationAttribute } from "./modal-add-cart";
import _ from "lodash";

interface IAddItemModelViewProps {
  openModal: boolean;
  addProduct: ShoppingCartItem;
  currentProductSelected: IProductItemSelectedModel;
  variationAttributes: IVariationAttribute[];
  isSelectedVariation: (va: IVariationAttributeModel) => boolean;
  isDisabledVariation: (va: IVariationAttributeModel) => boolean;
  handleSelectVariation: (va: IVariationAttributeModel) => void;
  handleCloseModal: () => void;
  handleDecreaseQuantity: () => void;
  handleIncreaseQuantity: () => void;
  handleSelectSingle: (modifiers: IProductModel[], modi: IProductModel) => void;
  handleSelectMultiple: (modi: IProductModel) => void;
  handleAddProduct: () => void;
}
export function AddItemModelViewDesktop({
  openModal,
  currentProductSelected,
  addProduct,
  variationAttributes,
  isDisabledVariation,
  isSelectedVariation,
  handleSelectVariation,
  handleCloseModal,
  handleDecreaseQuantity,
  handleIncreaseQuantity,
  handleSelectSingle,
  handleSelectMultiple,
  handleAddProduct,

}: IAddItemModelViewProps) {
  return (
    <ModalComponent
      portalClassName={`ModalAddItemDeskTop`}
      width={800}
      isCustomizeFooter={true}
      onCloseModal={handleCloseModal}
      isModal={true}
      isOpenModal={openModal}
    >
      <div className="info-product mb-5">
        <div className="flex justify-center mt-5">
          <div className="ava mr-2">
            <div className="img-container img--container-center">
              {currentProductSelected?.product?.images?.length > 0 ? (
                <img
                  src={redirectFileLocalUrl(
                    currentProductSelected?.product?.images?.length > 0 ? currentProductSelected?.product?.images[0] : "/images/food-place-holder.jpg"
                  )}
                  alt=""
                />
              ) : (
                <div className="avatar-thumb h-full w-full bg-yellow-50" />
              )}
            </div>
          </div>
          <div className="flex-auto">
            <div className="name text-md font-bold uppercase">
              {currentProductSelected?.product?.name}
            </div>

            <div className="text-red text-md font-bold uppercase">
              {formatMoney(
                currentProductSelected?.product?.variationProducts?.length > 0 ? currentProductSelected?.product.variationProducts.find(x => x.id === addProduct.productId)?.sellingPrice : currentProductSelected?.product?.sellingPrice,
                2,
                ".",
                ",",
                "$"
              )}
            </div>
            <div className="des mt-5">
              {currentProductSelected?.product?.variationProducts?.length > 0 ?
                (<div dangerouslySetInnerHTML={{ __html: currentProductSelected?.product.variationProducts.find(x => x.id === addProduct.productId)?.description ?? "" }}></div>)
                :
                <div dangerouslySetInnerHTML={{ __html: currentProductSelected?.product?.description }}></div>}
            </div>
          </div>
          <div className="quantity">
            <div className="quantity-container flex justify-between content-start items-start">
              <button onClick={handleDecreaseQuantity} className="btn--default">
                <IconMinus width={20} />
              </button>
              <span className="text-md">{addProduct?.quantity}</span>
              <button onClick={handleIncreaseQuantity} className="btn--default">
                <IconPlus width={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
      {currentProductSelected?.product?.variationProducts?.length > 0 && variationAttributes?.map((vp) => (
        <div
          className={`type mb-5  border-t border-gray-900 select-type`}
        >
          <div className="label-type p-1 px-2 bg-gray-900 block text-white ">
            {vp.variationName}
          </div>
          <div className="modifier-list mt-3 space-y-4">
            {vp.variationAttributes?.map((va) => (
              <div
                key={va.variationValueId}
                onClick={() => {
                  if (isDisabledVariation(va)) {
                    return;
                  }
                  handleSelectVariation(va);
                }}
                className="item__menu_desk flex justify-between"
              >
                <div className="info__modifier flex justify-between content-center items-center">
                  <div className="name text-sm font-semibold">
                    {va.variationValueName}
                  </div>
                </div>
                <div className="checkbox__content">
                  <div className="checkbox--container">
                    <input
                      type="radio"
                      name={va.variationName}
                      value={va.variationValueId}
                      checked={isSelectedVariation(va)}
                      disabled={isDisabledVariation(va)}
                    />
                    <span
                      className={`checkmark ${isDisabledVariation(va) ? 'disabled' : ''}`}
                      onClick={() => {
                        if (isDisabledVariation(va)) {
                          return;
                        }
                        handleSelectVariation(va);
                      }}
                    ></span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
      {currentProductSelected?.modifierGroups?.map((modifierGroup) => {
        return (
          <div
            className={`type mb-5  border-t border-gray-900 ${modifierGroup.selectType === SelectGroupTypeEnum.Single
              ? `select-type`
              : `select-modifier`
              }`}
          >
            <div className="label-type p-1 px-2 bg-gray-900 block text-white ">
              {modifierGroup.name}
            </div>
            <div className="modifier-list mt-3 space-y-4">
              {modifierGroup?.modifiers?.map((modi) => (
                <div
                  key={modi.id}

                  className="item__menu_desk flex justify-between"
                >
                  <div
                    onClick={() => {
                      if (modi.notAdded) {
                        return;
                      }
                      if (modifierGroup.selectType === SelectGroupTypeEnum.Single) {
                        handleSelectSingle(modifierGroup.modifiers, modi);
                      } else {
                        handleSelectMultiple(modi);
                      }
                    }}
                    className="info__modifier flex justify-between content-center items-center">
                    <div className="name text-sm font-semibold">
                      {modi.name} {modi.label && (<span style={{ color: "gray", fontWeight: "normal" }}>({modi.label})</span>)}
                    </div>
                    <div className="price text-sm font-semibold">
                      {formatMoney(modi.sellingPrice, 2, ".", ",", "$")}
                    </div>
                  </div>
                  <div className="checkbox__content">
                    {!modi.notAdded && (
                      (
                        modifierGroup.selectType === SelectGroupTypeEnum.Single ? (
                          <div className="checkbox--container">
                            <input
                              type="radio"
                              name={modifierGroup.name}
                              value={modi?.sellingPrice}
                              checked={
                                addProduct.modifiers?.filter(
                                  (m) => m.productId === modi.id
                                )?.length > 0
                              }
                            />
                            <span
                              className="checkmark"
                              onClick={() => {
                                handleSelectSingle(modifierGroup.modifiers, modi);
                              }}
                            ></span>
                          </div>
                        ) : (
                          <div className="checkbox--container">
                            <input
                              checked={
                                addProduct?.modifiers?.filter(
                                  (m) => m.productId === modi.id
                                ).length > 0
                              }
                              type="checkbox"
                              name={modifierGroup.name}
                              value={modi.id}
                            />
                            <span
                              className="checkmark"
                              onClick={() => {
                                handleSelectMultiple(modi);
                              }}
                            ></span>
                          </div>
                        )
                      )
                    )}

                  </div>
                </div>
              ))}
            </div>
          </div>
        );
      })}
      <div className="total-container pt-2 border-t  border-gray-300 modal--footer">
        <div className="btn--container">
          <button
            onClick={handleAddProduct}
            className="px-8 flex justify-center  w-full rounded-md shadow-lg py-2 transition-primary uppercase btn--primary"
          >
            <IconShoppingBag width={20} className="mr-2" /> add to cart{" "}
            {formatMoney(calculateTotal(addProduct), 2, ".", ",", "$")}
          </button>
        </div>
      </div>
    </ModalComponent>
  );
}
